import $ from 'jquery';
import * as htmlUtils from '../utils/html';

export default {
  bind(el, binding, vnode) {
    const rawName = binding.rawName;
    let stringId;
    let attr = null;

    if (rawName === 'v-word') {
      if (typeof binding.value === 'object') {
        stringId = binding.value.word;
        attr = binding.value.attr;
      } else {
        stringId = binding.value;
      }
    } else {
      stringId = rawName.replace('v-word:', '');
    }
    const inner = $('<div class="inner"></div>');
    const iconHolder = $(
      '<div class="icon-holder" style="display: inline; position: relative;"></div>',
    );


    $(el).addClass('wordingWrapper');
    let metaEl = el;
    inner.appendTo(iconHolder);

    if (
      $(el).prop('tagName') === 'INPUT' &&
      ['password', 'email', 'text'].includes($(el).attr('type'))
    ) {
      setTimeout(() => {
        iconHolder.insertAfter($(el));
        $(el)
          .parent()
          .addClass('wording-input-icon-holder');
        metaEl = $(el).parent()[0];
        initWordingsMeta(vnode, metaEl, stringId);
      });
    } else {
      iconHolder.appendTo($(el));
      initWordingsMeta(vnode, metaEl, stringId);
    }

    if (vnode.context.wordings) {
      function updateElementWording(newWordings) {
        let wording = newWordings[stringId];
        if (!wording) {
          wording = '';
        }
        if (attr) {
          $(el).attr(attr, htmlUtils.stripHTML(wording));
        } else {
          if (inner.html() !== wording) {
            inner.html(wording);
          }
        }
      }
      updateElementWording(vnode.context.wordings);
      vnode.context.$watch('wordings', {
        handler: newWordings => {
          updateElementWording(newWordings);
          onWordingReady(vnode);
        },
        deep: true,
      });
    } else {
      wordings().then(wordings => {
        let wording = wordings[stringId];
        if (!wording) {
          wording = '';
        }
        if (attr) {
          $(el).attr(attr, htmlUtils.stripHTML(wording));
        } else {
          inner.html(wording);
        }
      });
    }



    // el.addEventListener('input', () => {
    inner.on('input', () => {
      const change = {
        stringId,
        wording: inner.html(),
      };

      vnode.context.$emit('wordingChange', change);
    });

    inner[0].addEventListener('paste', evt => {
      evt.preventDefault();
      evt.stopPropagation();

      // Let's get only unformatted text from the clipboard,
      // we don't want fancy word formatting to be pasted.
      let clipboardContents = (
        evt.clipboardData || window.clipboardData
      ).getData('text/plain');

      window.document.execCommand('insertText', false, clipboardContents);
    });

    if (vnode.context.wordingsEditable) {
      // el.setAttribute("contenteditable", "true");
      inner.attr('contenteditable', 'true');
      inner.attr('data-wordingid', stringId);
    }
  },
};

function initWordingsMeta(vnode, metaEl, stringId) {
  let origClass = null;
  if (vnode.context.wordingsMeta) {
    vnode.context.$watch('wordingsMeta', newMeta => {
      let classes = '';

      if (vnode.context.wordingsMeta) {
        const wordingMeta = vnode.context.wordingsMeta[stringId];
        if (wordingMeta && wordingMeta.classes) {
          classes = wordingMeta.classes;
        }
      }
      if (
        !jQuery(metaEl).attr('class') ||
        jQuery(metaEl)
          .attr('class')
          .trim() !== classes.trim()
      ) {
        if (origClass === null) {
          origClass = $(metaEl).attr('class');
        }

        jQuery(metaEl).removeClass();
        jQuery(metaEl).addClass(origClass + ' ' + classes);
      }
    });
  }
}

function onWordingReady(vnode) {
  if (typeof vnode.context.onWordingReady === 'function') {
    vnode.context.onWordingReady();
  }
}



// WEBPACK FOOTER //
// ./src/directives/word.js